import {
  MdFolder,
  MdViewList,
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
} from '@bymason-private/legacy-pattern-components';

export function GroupingToggleButton({ grouping, onGroupingChange, ...props }: GroupingToggleButtonProps) {
  return (
    <ToggleButtonGroup value={grouping} exclusive onChange={onGroupingChange} {...props}>
      <ToggleButton value='flat'>
        <MdViewList />
      </ToggleButton>
      <ToggleButton value='grouped'>
        <MdFolder />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

interface GroupingToggleButtonProps extends Omit<ToggleButtonGroupProps, 'value' | 'onChange'> {
  grouping: 'flat' | 'grouped';
  onGroupingChange: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: unknown) => void;
}
